import { render, staticRenderFns } from "./SignUpFranchiseStepCongrats.vue?vue&type=template&id=4f207a3a&scoped=true&"
import script from "./SignUpFranchiseStepCongrats.vue?vue&type=script&lang=js&"
export * from "./SignUpFranchiseStepCongrats.vue?vue&type=script&lang=js&"
import style0 from "./SignUpFranchiseStepCongrats.vue?vue&type=style&index=0&id=4f207a3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f207a3a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Confetti: require('/home/circleci/repo/components/Confetti.vue').default})
